// Cashflow feature — shared constants extracted from DailyCashflow.tsx

export const HORIZON_OPTIONS = [
    { label: '7 days', value: 7 },
    { label: '14 days', value: 14 },
    { label: '30 days', value: 30 },
    { label: '60 days', value: 60 },
    { label: '90 days', value: 90 },
];

export const CATEGORY_COLORS: Record<string, string> = {
    Food:     '#f97316',
    Debt:     '#ef4444',
    School:   '#8b5cf6',
    Housing:  '#0ea5e9',
    Car:      '#64748b',
    Bday:     '#ec4899',
    Donation: '#14b8a6',
    Other:    '#94a3b8',
};

export const categoryColor = (tag: string) =>
    CATEGORY_COLORS[tag] || CATEGORY_COLORS.Other;

export const ROW_HEIGHT = 36;

// Grid column templates for each virtualized tab
export const ENTRIES_COLS = '40px 1fr 75px 90px 90px 90px 80px 68px';
export const ENTRIES_COLS_MOBILE = '36px 1fr 80px 72px'; // Checkbox | Title | Amount | Date
export const ENTRIES_COLS_MOBILE_BROWSE = '1fr 80px 72px'; // Title | Amount | Date (no checkbox)
